import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.css'
})
export class FAQComponent {
   faqs = [
    { 
      question: 'What is Buddie Beatz?', 
      answer: 'Buddie Beatz is an extremely localized online music streaming APP that is designed and developed to cater to the needs of music lovers in Zimbabwe. The app brings thousands of exclusive tracks from Zimbabwean artists.', 
      open: false, 
      isHtml: false 
    },
    { 
      question: 'Where do I access Buddie Beatz music app?', 
      answer: 'To get Buddie Beatz music app, download it on Google Play or the iOS App Store.', 
      open: false, 
      isHtml: false 
    },
    { 
      question: 'How can I register on Buddie Beatz?', 
      answer: 'After installing the downloaded application on your mobile phone, enter your Econet mobile number to create a Buddie Beatz account. If you are using mobile data from your Econet number, it will register you automatically. If you are using Wi-Fi or any other data connection, it will prompt you to enter your Econet Number, and then you will receive an OTP on your Econet number to verify. Once the OTP is verified, your registration is completed.', 
      open: false, 
      isHtml: false 
    },
    { 
      question: 'How do I subscribe to the application?', 
      answer: 'After registering for your account, the app will prompt you with options for different packages you can subscribe to.', 
      open: false, 
      isHtml: false 
    },
    { 
      question: 'What are the subscription charges on Buddie Beatz music app?', 
      answer: `
        <table class="faq-table">
          <thead>
            <tr>
              <th>Package</th>
              <th>Charges ($ RTGS)</th>
              <th>Free Data Allocation (MB)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Daily</td>
              <td>$0.50</td>
              <td>50</td>
            </tr>
            <tr>
              <td>Weekly</td>
              <td>$2.00</td>
              <td>200</td>
            </tr>
            <tr>
              <td>Monthly</td>
              <td>$5.00</td>
              <td>600</td>
            </tr>
          </tbody>
        </table>`, 
      open: false, 
      isHtml: true 
    },
    { 
      question: 'How can I listen to Buddie Beatz music?', 
      answer: 'You can listen to Buddie Beatz on iOS or Android-enabled smartphones for as long as you have an active subscription plan, data allocation available, or airtime in your main account or any other data bundle.', 
      open: false, 
      isHtml: false 
    },
    { 
      question: 'Why do I need a Buddie Beatz account?', 
      answer: 'Buddie Beatz account will enable you to get premium features like listening to full songs, adding songs to your favorite playlist, setting any song as your CRBT, and downloading songs to play when you are offline.', 
      open: false, 
      isHtml: false 
    },
    { 
      question: 'Which version of Android/iOS do I need for me to download and stream?', 
      answer: 'Android 4.4 or iOS 6.0 and above.', 
      open: false, 
      isHtml: false 
    },
    { 
      question: 'How can my phone storage help me in getting a better user experience?', 
      answer: 'Buddie Beatz, as an app, will not consume much of your phone’s storage. Less storage on your phone does not directly affect your listening experience since the songs are streamed through the internet for listening. However, for offline use of the app and playing songs, the app will download the songs on your phone\'s memory (Internal / External), consuming the storage space on your phone. The more usable storage available, the more songs you can download to listen to when offline.', 
      open: false, 
      isHtml: false 
    },
    { 
      question: 'Do I need to be connected to the Internet to listen to Buddie Beatz?', 
      answer: 'Yes, you need to have an internet Wi-Fi connection or mobile data plan to use online streaming, share, add to favorites, and save offline features of the Buddie Beatz music app. You do not need an internet connection for listening to songs saved for offline listening.', 
      open: false, 
      isHtml: false 
    },
    { 
      question: 'How do I check for free data balance?', 
      answer: 'On the app, go to the main menu and click on "My Account"; your balance will show.', 
      open: false, 
      isHtml: false 
    },
    { 
      question: "How do I change the number that is subscribed to the app?", 
      answer: "<b>N.B:</b> If you want to change the number you subscribed with, you will lose your data and downloaded songs.<br><br><b>To change the number:</b><br>1. Unsubscribe from the package subscribed through the app.<br>2. Clear app data by going to settings (If you don’t clear app data, it will use the same number again. This is very important).<br>3. Delete the Buddie Beatz music folder from My Files. (If this folder is not deleted, the new user cannot download the songs which were downloaded using the old number. This will clear the downloaded cache. This is very important).<br><br>Now, use the new number and log in to the app. You will be treated as a new subscriber.", 
      open: false, 
      isHtml: true 
    },
    { 
      question: "What happens when I exhaust my free Buddie Beatz data allocation?", 
      answer: "Once your Buddie Beatz bundle is exhausted, your normal data bundle will be used automatically. If your out-of-bundle browsing is ON, it will use your main account (airtime) as well.<br><br>If your out-of-bundle browsing is OFF, it will stop playing songs/downloads after all your bundles are exhausted.<br><br>In case you have valid subscriptions and you don’t have any data bundle to listen to Buddie Beatz music, you can:<br>- Purchase additional data from Econet by dialing *143#.<br>- Use any Wi-Fi network to browse.", 
      open: false, 
      isHtml: true 
    }
  ];
  
  toggleAnswer(faq: any) {
    faq.open = !faq.open;
  }
}
